import Vue from "vue";
import Router from "vue-router";
import store from "@/modules/admin/store";

Vue.use(Router);

let routes = [
  {
    path: "/dashboard",
    component: () => import("./modules/admin/pages/dashboard/Index"),
    meta: { permission: "dashboard" },
  },

  {
    path: "/web-analytics",
    component: () => import("./modules/admin/pages/web-analytics/Index"),
    meta: { permission: "dashboard" },
  },

  {
    path: "/wifi/vendors",
    component: () => import("./modules/admin/pages/wifi/Index.vue"),
    meta: { permission: "wifi" },
  },

  {
    path: "/wifi/vendors/create",
    component: () => import("./modules/admin/pages/wifi/Create.vue"),
    meta: { permission: "wifi" },
  },

  {
    path: "/wifi/vendors/:id",
    component: () => import("./modules/admin/pages/wifi/Show.vue"),
    meta: { permission: "wifi" },
  },

  {
    path: "/wifi/vendors/:id/edit",
    component: () => import("./modules/admin/pages/wifi/Edit.vue"),
    meta: { permission: "wifi" },
  },

  // FeedBack Routes ...
  {
    path: "/feedback",
    component: () => import("./modules/admin/pages/feedback/Index.vue"),
    meta: { permission: "users" },
  },

  // Analytics Routes ...
  {
    path: "/analytics/overview",
    component: () => import("./modules/admin/pages/analytics/Overview"),
    meta: { permission: "analytics" },
  },

  {
    path: "/analytics/user-analytics",
    component: () =>
      import("./modules/admin/pages/analytics/user-analytics/Index.vue"),
    meta: { permission: "analytics" },
  },

  {
    path: "/analytics/order-analytics",
    component: () =>
      import("./modules/admin/pages/analytics/order-analytics/Index.vue"),
    meta: { permission: "report" },
  },

  {
    path: "/analytics/reading/detail",
    component: () =>
      import("./modules/admin/pages/analytics/reading/Detail.vue"),
    meta: { permission: "analytics" },
  },

  {
    path: "/analytics/downloads",
    component: () => import("./modules/admin/pages/analytics/GenerateReport"),
    meta: { permission: "report" },
  },

  {
    path: "/analytics/views",
    component: () => import("./modules/admin/pages/analytics/GenerateReport"),
    meta: { permission: "report" },
  },

  {
    path: "/analytics/promo",
    component: () => import("./modules/admin/pages/promo/Index"),
    meta: { permission: "promotion" },
  },

  {
    path: "/analytics/promo/:id",
    component: () => import("./modules/admin/pages/promo/Show"),
    meta: { permission: "promotion" },
  },

  {
    path: "/analytics/promo/:id/coupons",
    component: () => import("./modules/admin/pages/promo/ShowCoupons"),
    meta: { permission: "promotion" },
  },

  // User Routes ...
  {
    path: "/users",
    component: require("./modules/admin/pages/users/Index.vue").default,
    children: [
      {
        path: "/",
        component: require("./modules/admin/pages/users/components/AddNew.vue")
          .default,
        meta: { permission: "users" },
      },
    ],
  },

  {
    path: "/users/:id",
    component: require("./modules/admin/pages/users/Show.vue").default,
    meta: { permission: "users" },
    children: [
      {
        path: "/",
        component: require("./modules/admin/pages/users/info/Index.vue")
          .default,
        meta: { permission: "users" },
      },
      {
        path: "devices",
        component: require("./modules/admin/pages/users/devices/Index.vue")
          .default,
        meta: { permission: "users" },
      },
      {
        path: "downloads",
        component: require("./modules/admin/pages/users/downloads/Index.vue")
          .default,
        meta: { permission: "users" },
      },
      {
        path: "views",
        component: require("./modules/admin/pages/users/views/Index.vue")
          .default,
        meta: { permission: "users" },
      },

      {
        path: "purchases",
        component: require("./modules/admin/pages/users/purchases/Index.vue")
          .default,
        meta: { permission: "users" },
      },
    ],
  },
  // Review App Routes ...
  {
    path: "/review-app/accounts",
    component: require("./modules/admin/pages/review-app/accounts/Index.vue")
      .default,
    meta: { permission: "review_accounts" },
  },

  // Feeds Routes ...
  {
    path: "/feeds",
    component: require("./modules/admin/pages/feeds/Index.vue").default,
    meta: { permission: "magazine" },


  },
  {
    path: "/feeds/:id/edit",
    component: require("./modules/admin/pages/feeds/Edit.vue").default,
    meta: { permission: "magazine" },
  },

  // Magazine Routes...
  {
    path: "/magazine/magazines",
    component: require("./modules/admin/pages/magazine/magazines/Index.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazines/create",
    component: require("./modules/admin/pages/magazine/magazines/Form.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazines/:id",
    component: require("./modules/admin/pages/magazine/magazines/Show.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazines/:id/edit",
    component: require("./modules/admin/pages/magazine/magazines/Form.vue")
      .default,
    meta: { permission: "magazine" },
  },

  // Magazine issue Routes...
  {
    path: "/magazine/magazine/issues",
    component: require("./modules/admin/pages/magazine/magazines/issues/Index.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazine/issues/create",
    component: require("./modules/admin/pages/magazine/magazines/issues/Create.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazine/issues/:id/stats/:type",
    component: require("./modules/admin/pages/magazine/magazines/issues/Stats.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazine/issues/:id",
    component: require("./modules/admin/pages/magazine/magazines/issues/Show.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/magazine/issues/:id/edit",
    component: require("./modules/admin/pages/magazine/magazines/issues/Edit.vue")
      .default,
    meta: { permission: "magazine" },
  },

  // Magazine campaign Routes...
  {
    path: "/campaigns",
    component: require("./modules/admin/pages/magazine/campaigns/Index.vue")
      .default,
    meta: { permission: "promotion" },
  },

  {
    path: "/campaigns/create",
    component: require("./modules/admin/pages/magazine/campaigns/Create.vue")
      .default,
    meta: { permission: "promotion" },
  },

  {
    path: "/campaigns/:id",
    component: require("./modules/admin/pages/magazine/campaigns/Show.vue")
      .default,
    meta: { permission: "promotion" },
  },

  {
    path: "/campaigns/:id/edit",
    component: require("./modules/admin/pages/magazine/campaigns/Edit.vue")
      .default,
    meta: { permission: "promotion" },
  },

  // Magazine charts Routes ...
  {
    path: "/magazine/downloads",
    component: require("./modules/admin/pages/magazine/stats/downloads/Index.vue")
      .default,
    meta: { permission: "analytics" },
  },

  {
    path: "/revenue/shares",
    component: require("./modules/admin/pages/revenue/incomes/Index.vue")
      .default,
    meta: { permission: "revenue" },
  },

  {
    path: "/revenue/reports",
    component: require("./modules/admin/pages/revenue/reports/Index.vue")
      .default,
    meta: { permission: "revenue" },
  },

  {
    path: "/magazine/incomes/:id",
    component: require("./modules/admin/pages/revenue/incomes/Show.vue")
      .default,
    meta: { permission: "revenue" },
  },

  {
    path: "/magazine/stats/downloads",
    component: require("./modules/admin/pages/magazine/stats/downloads/Index.vue")
      .default,
    meta: { permission: "analytics" },
  },

  {
    path: "/magazine/stats/read-pages",
    component: require("./modules/admin/pages/magazine/stats/read-pages/Index.vue")
      .default,
    meta: { permission: "analytics" },
  },

  {
    path: "/magazine/contents",
    component: require("./modules/admin/pages/magazine/contents/Index.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/categories",
    component: require("./modules/admin/pages/magazine/categories/Index.vue")
      .default,
    meta: { permission: "magazine" },
  },
  {
    path: "/magazine/categories/:id/edit",
    component: require("./modules/admin/pages/magazine/categories/Edit.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/categories/add",
    component: require("./modules/admin/pages/magazine/categories/Add.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/magazine/subscriptions",
    component: require("./modules/admin/pages/magazine/subscriptions/Index.vue")
      .default,
    meta: { permission: "subscription" },
  },

  {
    path: "/magazine/complementary-access",
    component: require("./modules/admin/pages/magazine/issue-complementary/Index.vue")
      .default,
    meta: { permission: "subscription" },
  },

  {
    path: "/magazine/complementary-access/:id",
    component: require("./modules/admin/pages/magazine/issue-activations/Index.vue")
      .default,
    meta: { permission: "subscription" },
  },

  {
    path: "/collections",
    component: require("./modules/admin/pages/collections/Index.vue")
      .default,
    meta: { permission: "magazine" },
  },

  {
    path: "/collections/:id/edit",
    component: require("./modules/admin/pages/collections/Edit.vue")
      .default,
    meta: { permission: "magazine" },
  },

  // Magazine Coupon Routes ...
  {
    path: "/magazine/coupons",
    component: require("./modules/admin/pages/magazine/coupons/Index.vue")
      .default,
    meta: { permission: "subscription" },
  },
  {
    path: "/magazine/coupons/create",
    component: require("./modules/admin/pages/magazine/coupons/Create.vue")
      .default,
    meta: { permission: "subscription" },
  },
  {
    path: "/magazine/coupons/:id/edit",
    component: require("./modules/admin/pages/magazine/coupons/Edit.vue")
      .default,
    meta: { permission: "subscription" },
  },
  {
    path: "/magazine/coupons/:id",
    component: require("./modules/admin/pages/magazine/coupons/Show.vue")
      .default,
    meta: { permission: "subscription" },
  },

  // Ads Routes ...
  {
    path: "/ads-views",
    component: require("./modules/admin/pages/ads-views/Index.vue").default,
    meta: { permission: "ads" },
  },

  {
    path: "/ads",
    component: require("./modules/admin/pages/adses/Index.vue").default,
    meta: { permission: "ads" },
  },

  {
    path: "/ads/:id/edit",
    component: require("./modules/admin/pages/adses/Edit.vue").default,
    meta: { permission: "ads" },
  },

  {
    path: "/ads/create",
    component: require("./modules/admin/pages/adses/Create.vue").default,
    meta: { permission: "ads" },
  },

  {
    path: "/orders",
    component: require("./modules/admin/pages/orders/Index.vue").default,
    meta: { permission: "subscription" },
  },

  {
    path: "/sales",
    component: () => import("./modules/admin/pages/sales/Index"),
    meta: { permission: "subscription" },
  },

  {
    path: "/accounting/undistributed",
    component: require("./modules/admin/pages/accounting/undistributed/Index.vue")
      .default,
    meta: { permission: "subscription" },
  },

  {
    path: "/orders/:id",
    component: require("./modules/admin/pages/orders/Show.vue").default,
    meta: { permission: "subscription" },
  },

  // Publisher Routes ...
  {
    path: "/publishers",
    component: require("./modules/admin/pages/publishers/Index.vue").default,
    meta: { permission: "publishers" },
  },

  {
    path: "/publishers/:id/edit",
    component: require("./modules/admin/pages/publishers/Edit.vue").default,
    meta: { permission: "publishers" },
  },

  {
    path: "/publishers/:id",
    component: require("./modules/admin/pages/publishers/Show.vue").default,
    meta: { permission: "publishers" },
    children: [
      {
        path: "/",
        component: require("./modules/admin/pages/publishers/info/Index.vue")
          .default,
        meta: { permission: "publishers" },
      },
      {
        path: "managers",
        component: require("./modules/admin/pages/publishers/managers/Index.vue")
          .default,
        meta: { permission: "publishers" },
      }
    ],
  },

  // Marketing ...
  {
    path: "/marketing/sliders",
    component: require("./modules/admin/pages/marketing/sliders/Index.vue")
      .default,
    meta: { permission: "banners" },
  },

  {
    path: "/marketing/sliders/:id",
    component: require("./modules/admin/pages/marketing/sliders/Edit.vue")
      .default,
    meta: { permission: "banners" },
  },

  {
    path: "/marketing/banners",
    component: require("./modules/admin/pages/marketing/banners/Index.vue")
      .default,
    meta: { permission: "banners" },
  },

  {
    path: "/marketing/banners/:id",
    component: require("./modules/admin/pages/marketing/banners/Edit.vue")
      .default,
    meta: { permission: "banners" },
  },

  // Tools ...
  {
    path: "/settings",
    component: require("./modules/admin/pages/settings/Index.vue").default,
    meta: { permission: "settings" },
  },

  {
    path: "/mass-mail",
    component: require("./modules/admin/pages/mass-mail/Index.vue").default,
    meta: { permission: "settings" },
  },

  // Devices ...
  {
    path: "/devices",
    component: require("./modules/admin/pages/devices/Index.vue").default,
    meta: { permission: "users" },
  },

  {
    path: "/devices/:id",
    component: require("./modules/admin/pages/devices/Show.vue").default,
    meta: { permission: "users" },
    children: [
      {
        path: "/",
        component: require("./modules/admin/pages/devices/info/Index.vue")
          .default,
        meta: { permission: "users" },
      },
      {
        path: "users",
        component: require("./modules/admin/pages/devices/users/Index.vue")
          .default,
        meta: { permission: "users" },
      },
    ],
  },

  // Searches ...
  {
    path: "/searches",
    component: require("./modules/admin/pages/searches/Index.vue").default,
    meta: { permission: "logs" },
  },

  // Reviews ...
  {
    path: "/reviews",
    component: require("./modules/admin/pages/reviews/Index.vue").default,
    meta: { permission: "users" },
  },

  // Activity Log
  {
    path: "/activity-log",
    component: require("./modules/admin/pages/activity-log/Index.vue").default,
    meta: { permission: "logs" },
  },

  {
    path: "/support/tickets",
    component: require("./modules/admin/pages/support/tickets/Index.vue")
      .default,
    meta: { permission: "logs" },
  },

  {
    path: "/support/tickets/:id",
    component: require("./modules/admin/pages/support/tickets/Show.vue")
      .default,
    meta: { permission: "logs" },
  },

  {
    path: "/email-addresses",
    component: require("./modules/admin/pages/email-addresses/Index.vue")
      .default,
    meta: { permission: "users" },
  },

  {
    path: "/managers",
    component: require("./modules/admin/pages/managers/Index.vue").default,
    meta: { permission: "managers" },
  },

  {
    path: "/pns",
    component: require("./modules/admin/pages/pns/Index.vue").default,
    meta: { permission: "notifications" },
  },

  {
    path: "/pns/notifications/:id",
    component: require("./modules/admin/pages/pns/notifications/Show.vue")
      .default,
    meta: { permission: "notifications" },
  },

  {
    name: "compose_notification",
    path: "/pns/compose",
    component: require("./modules/admin/pages/pns/Compose.vue").default,
    props: true,
    meta: { permission: "notifications" },
  },

  {
    name: "notification_message",
    path: "/pns/scheduled",
    component: require("./modules/admin/pages/pns/ScheduledNofication.vue").default,
    props: true,
    meta: { permission: "notifications" },
  },


  {
    path: "/app/settings",
    component: require("./modules/admin/pages/app/Settings.vue").default,
    meta: { permission: "settings" },
  },

  // Otherwise Redirect To Dashboard
  { path: "*", redirect: "/dashboard" },
];

const router = new Router({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (from.path !== '/') {
    localStorage.setItem('previous', from.path);
  }

  if (!store.state.auth.manager) {
    await store.dispatch("loadUser");
  }

  if (
    to.meta.permission &&
    store.state.auth.manager &&
    store.state.auth.manager.permissions.includes(to.meta.permission)
  ) {
    return next();
  }

  return false;
});

export default router;
